// Singleton requestAnimationFrame loop shared by all canvas-driven animated
// widgets (GIFs, videos). One RAF callback iterates through registered tickers
// and asks fabric to redraw only when at least one ticker reports a frame
// advance. This keeps idle GIFs from burning CPU between frame delays.

let _activeCount = 0;
let _renderLoopId = null;
let _canvasRef = null;
let _lastFrameTime = 0;
const FRAME_INTERVAL = 33; // ~30fps cap

const _tickers = new Set();

export function registerTicker(ticker) {
    _tickers.add(ticker);
}

export function unregisterTicker(ticker) {
    _tickers.delete(ticker);
}

export function startRenderLoop(canvas) {
    if (_renderLoopId !== null) return;
    _canvasRef = canvas;
    const loop = (time) => {
        _renderLoopId = requestAnimationFrame(loop);
        if (time - _lastFrameTime < FRAME_INTERVAL) return;
        _lastFrameTime = time;
        let dirty = false;
        _tickers.forEach((tick) => {
            if (tick()) dirty = true;
        });
        if (dirty && _canvasRef) {
            _canvasRef.requestRenderAll();
        }
    };
    _renderLoopId = requestAnimationFrame(loop);
}

export function stopRenderLoop() {
    if (_renderLoopId !== null) {
        cancelAnimationFrame(_renderLoopId);
        _renderLoopId = null;
        _canvasRef = null;
        _lastFrameTime = 0;
    }
}

export function incrementActive() {
    return ++_activeCount;
}

export function decrementActive() {
    _activeCount = Math.max(0, _activeCount - 1);
    return _activeCount;
}

export function getActiveCount() {
    return _activeCount;
}
